import { reportsApi } from 'Api/axios/reports-api';
import { useEffect, useState } from 'react';
import type { EmployeeReportI, EmployeeReportFilterI } from 'types';
import type { ReportsPaginationI } from 'Pages/reports/components/ReportsDataGrid/types';

interface Props {
  init?: boolean;
}

const useEmployeesReportApi = ({ init = false }: Props) => {
  const [data, setData] = useState<EmployeeReportI[]>([]);
  const [pagination, setPagination] = useState<ReportsPaginationI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEmployeesReport = async (filters: EmployeeReportFilterI = {}) => {
    setLoading(true);
    const response = await reportsApi.readEmployees(filters);
    setLoading(false);
    if (response.data) {
      setData(response.data ?? []);
      setPagination(response.pagination ?? null);
    } else {
      setError(response.error ?? 'No hay datos disponibles');
    }
  };

  useEffect(() => {
    if (init) {
      fetchEmployeesReport({ page: 1, pageSize: 15 });
    }
  }, [init]);

  return { data, pagination, loading, error, fetchEmployeesReport };
};

export default useEmployeesReportApi;
